import { render, staticRenderFns } from "./sepet.vue?vue&type=template&id=b99f5376&scoped=true&"
import script from "./sepet.vue?vue&type=script&lang=js&"
export * from "./sepet.vue?vue&type=script&lang=js&"
import style0 from "./sepet.vue?vue&type=style&index=0&id=b99f5376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99f5376",
  null
  
)

export default component.exports